import React, { useCallback, useRef } from 'react';

import {
  makeAddBookmarkContentUseCase,
  makeRemoveBookmarkContentUseCase,
} from '@mais-retorno-front/core-business';
import { useBookmarkContent } from '@mais-retorno-front/hooks/bookmark-content';
import { CustomizedContentCard } from './components/customized-content-card';

import { Container, ContentListCard } from './styles';
import { LoadingContentCards } from './components/loading-content-cards';
import { ICustomizedContentCardListProps } from './interface';
import { IContent } from '@mais-retorno-front/models/content';
import { withEmptyContent } from './withEmptyContent';
import { useSnackbar } from '@core/design-system/snackbar';

const InternalCustomizedContentCardList = ({
  contents,
  loading = false,
}: ICustomizedContentCardListProps) => {
  const { openSnackbar } = useSnackbar();

  const addBookmarkContentUseCase = makeAddBookmarkContentUseCase();
  const removeBookmarkContentUseCase = makeRemoveBookmarkContentUseCase();
  const { bookmarksIds, setBookmarksIds } = useBookmarkContent();

  const handleAddBookmarkContent = useCallback(
    async (content: IContent): Promise<void> => {
      const { success, message } = await addBookmarkContentUseCase.handle({
        content_id: content.contentId,
        content_slug: content.slug,
        content_type: content.type,
      });

      openSnackbar({
        type: success ? 'success' : 'error',
        message,
      });
    },
    [addBookmarkContentUseCase]
  );

  const handleRemoveBookmarkContent = useCallback(
    async (content_id: number): Promise<void> => {
      const { success, message } = await removeBookmarkContentUseCase.handle(
        content_id
      );

      openSnackbar({
        type: success ? 'success' : 'error',
        message,
      });
    },
    [removeBookmarkContentUseCase]
  );

  if (loading) {
    return <LoadingContentCards />;
  }

  return (
    <>
      <Container>
        <ContentListCard>
          {contents?.map((content, index) => (
            <CustomizedContentCard
              index={index}
              key={content.slug}
              content={content}
              setBookmarksIds={setBookmarksIds}
              bookmarkContentExist={bookmarksIds.includes(content.slug)}
              handleAddBookmarkContent={handleAddBookmarkContent}
              handleRemoveBookmarkContent={handleRemoveBookmarkContent}
            />
          ))}
        </ContentListCard>
      </Container>
    </>
  );
};

export const CustomizedContentCardList = withEmptyContent(
  InternalCustomizedContentCardList
);

export * from './interface';
